import React from "react";
import { Breadcrumbs, Typography, Link, Button, useTheme } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useLocation, useNavigate } from "react-router-dom";

const pathNameMap = {
  "": "หน้าหลัก",
  products: "รายการสินค้า",
  categories: "หมวดหมู่สินค้า",
  branches: "จัดการสาขา",
  pricing: "จัดการราคา",
  groups: "จัดการกลุ่มลูกค้า",
  users: "จัดการพนักงาน",
  reports: "ธุรกรรม",
  "step-price": "ราคาขั้นบันไดแบบหมวดหมู่",
  permissions: "สิทธิ์การเข้าถึง"
};

const groupedPaths = ["checkout"];

export default function AppBreadcrumbs() {
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme(); // รับ theme ปัจจุบัน

  const pathnames = location.pathname
    .split("/")
    .filter((x) => x && isNaN(Number(x)));

  let breadcrumbs = [];
  let grouped = false;

  for (let i = 0; i < pathnames.length; i++) {
    const segment = pathnames[i];
    const isGrouped = groupedPaths.includes(segment);

    if (grouped) {
      continue;
    }

    let to = `/${pathnames.slice(0, i + 1).join("/")}`;
    let label = pathNameMap[segment] || segment;

    if (isGrouped) {
      to = `/${pathnames.slice(0, i + 1).join("/")}`;
      label = pathNameMap[segment];
      breadcrumbs.push({ label, to, isLast: true });
      grouped = true;
      break;
    }

    breadcrumbs.push({ label, to, isLast: i === pathnames.length - 1 });
  }

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      sx={{
        backgroundColor:
          theme.palette.mode === "dark"
            ? theme.palette.background.paper
            : "#f5f5f5",
        p: 2,
        borderRadius: 2,
      }}
    >
      <Link
        underline="none"
        color="inherit"
        onClick={() => navigate("/products")}
        sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
      >
        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
        หน้าหลัก
      </Link>

      {breadcrumbs.map(({ label, to, isLast }) =>
        isLast ? (
          <Typography key={to} color="text.primary">
            {label}
          </Typography>
        ) : (
          <Button
            key={to}
            variant="contained"
            onClick={() => navigate(to)}
            sx={{ textTransform: "none", borderRadius: 4 }}
            color="success"
          >
            {label}
          </Button>
        )
      )}
    </Breadcrumbs>
  );
}
